import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectFeeWaiverFee {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any,
  disabled?: any,
}

export const SelectFeeWaiverFee = ({
  onChange,
  selected,
  defaultSelected,
  style,
  disabled

}: SelectFeeWaiverFee) => {
  const itemList = useStoreState((state) => state.saccount.waiverList);
  const itemListFetch = useStoreActions((state) => state.saccount.fetchwaiverList);
  //const thanaListFetch = useStoreActions((state) => state.common.thanaListFetch);
  if (itemList === null) {
    itemListFetch();
  }
  
  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.id === id);
      onChange(value.id);
    }
  };

  // React.useEffect(() => {
  //   if (selected) {
  //     thanaListFetch(selected?.districtId);
  //   }
  // }, [selected])


  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      disabled={disabled}
      value={selected}
      style={style}
      placeholder="Select Fee Waiver"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.id} value={type.id}>
            {type.name}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Fee Waiver</Option>
      )}
    </Select>
  );
};
